// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"c2a61e40","108":"283a0f3c","112":"54bab0df","147":"684c6258","233":"fe1c35e0","574":"22bfc41c","615":"34e2f982","807":"53573cf7","818":"92994f22","899":"46a0123e","900":"b97305bc"}[chunkId] + ".chunk.js";
};